import React, { useCallback, useMemo, useState } from 'react'

import { Grid, List, makeStyles } from '@material-ui/core'

import InputGroup from '../../../../UI/Forms/InputGroup/InputGroup'
import UserFeedbackCard from './UserFeedbackCard/UserFeedbackCard'

const UserList = ({ onUserClicked, selectedEmpId, users }) => {
  const classes = makeStyles({
    root: {
      minHeight: 300,
      maxHeight: 'calc(90vh - 150px)',
      overflow: 'auto'
    }
  })()
  const [filterText, setFilterText] = useState('')

  const onFilterTextChangedHandler = useCallback(e => {
    setFilterText(e.target.value)
  }, [])

  const userList = useMemo(
    () =>
      users
        .filter(user => user.full_name.includes(filterText))
        .map(user => (
          <UserFeedbackCard
            key={user.emp_id}
            selected={selectedEmpId === user.emp_detail_id }
            onClick={() => onUserClicked(user)}
            user={user}
          />
        )),
    [selectedEmpId, onUserClicked, users, filterText]
  )

  return (
    <Grid container direction={'column'}>
      <Grid item>
        <InputGroup
          label={'Search'}
          variant={'outlined'}
          changed={onFilterTextChangedHandler}
          inputValue={filterText}
          inputType={'input'}
          configs={{ size: 'small' }}
          noMargin
        />
      </Grid>
      <Grid item>
        <List classes={classes}>{userList}</List>
      </Grid>
    </Grid>
  )
}

export default UserList
